// material-ui
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ bgColor, fgColor, accentColor, logoSize }) => {
    const theme = useTheme();

    return (
        <svg
            style={{ width: logoSize ? `calc(24px * ${logoSize})` : '24px' }}
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            viewBox="0 0 1024 1024"
        >
            <path
                fill={fgColor}
                d="M310.28 405.47v.13a58.86 58.86 0 0 0-57.64 58.8h57.64v294.67h57.63V464.4h288.18v176.8h57.63V464.27a58.87 58.87 0 0 0 57.64-58.8Z"
            />
            <path
                fill={fgColor}
                d="M425.55 641.2v119.17A57.63 57.63 0 0 0 483.18 818V698.83a57.63 57.63 0 0 0-57.63-57.63ZM425.55 524.63a57.64 57.64 0 0 0 57.63 57.64v-58.94h-57.63ZM540.82 612.36a57.64 57.64 0 0 0 57.63-57.64v-31.39h-57.63ZM656.09 757.77v1.3h57.63v-58.94a57.64 57.64 0 0 0-57.63 57.64ZM540.77 727.72V818h57.68V670a57.69 57.69 0 0 0-57.68 57.72ZM195 287.6a58.93 58.93 0 0 0 58.93 58.93H829V287.6Z"
            />
        </svg>
    );
};
Logo.propTypes = {
    bgColor: PropTypes.string,
    fgColor: PropTypes.string,
    accentColor: PropTypes.string,
    logoSize: PropTypes?.number
};
export default Logo;
